import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SdsClaimForm } from '../moh-send-claim-dialog.component';
import { MohSdsTreatmentReason } from '@principle-theorem/principle-core/interfaces';
import { ReactiveFormsModule } from '@angular/forms';
import { NgMaterialModule } from '@principle-theorem/ng-material';
import { NgSharedModule, TypedFormGroup } from '@principle-theorem/ng-shared';
import { getEnumValues } from '@principle-theorem/shared';
import { Observable, ReplaySubject } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

interface ISdsFormTreatmentReasonInfo {
  label: string;
  hint?: string;
}

@Component({
  selector: 'pr-moh-sds-claim-form',
  imports: [ReactiveFormsModule, NgMaterialModule, NgSharedModule],
  templateUrl: './moh-sds-claim-form.component.html',
  styleUrl: './moh-sds-claim-form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MohSdsClaimFormComponent {
  form$ = new ReplaySubject<TypedFormGroup<SdsClaimForm>>(1);
  treatmentReasons = getEnumValues(MohSdsTreatmentReason);
  reasonHint$: Observable<string>;

  treatmentReasonsMap: Record<
    MohSdsTreatmentReason,
    ISdsFormTreatmentReasonInfo
  > = {
    [MohSdsTreatmentReason.AsReferred]: {
      label: 'As referred',
      hint: 'Please enter referral number',
    },
    [MohSdsTreatmentReason.EmergencyCohsEnrolled]: {
      label: 'Emergency care for child enrolled in COHS',
      hint: `Please provide patient's dental clinic/school and town`,
    },
    [MohSdsTreatmentReason.TreatmentCohsWithoutReferral]: {
      label: 'Child enrolled in COHS without referral',
      hint: `Please provide patient's dental clinic/school and town`,
    },
    [MohSdsTreatmentReason.EmergencyAdolescentOtherProvider]: {
      label: 'Emergency care for child enrolled with another provider',
      hint: 'Please provide name of usual provider and town/city',
    },
    [MohSdsTreatmentReason.EmergencyNotEnrolled]: {
      label: 'Emergency care for child not enrolled in COHS',
    },
  };

  @Input()
  set form(form: TypedFormGroup<SdsClaimForm>) {
    if (form) {
      this.form$.next(form);
    }
  }

  constructor() {
    this.reasonHint$ = this.form$.pipe(
      switchMap((form) => form.controls.treatmentReason.valueChanges),
      map((treatmentReason) =>
        treatmentReason
          ? this.treatmentReasonsMap[treatmentReason].hint ?? ''
          : ''
      )
    );
  }
}
